import { AnalyticsTrackingEvent } from "../analytics/events.js";
const buildTrackingParams = ({
  trackingParams,
  mainEntity
}) => {
  var _a;
  const queryParams = {
    ...trackingParams || {}
  };
  if ((mainEntity == null ? void 0 : mainEntity.type) === "product") {
    queryParams.sku = mainEntity == null ? void 0 : mainEntity.entity.stacklineSku;
    queryParams.stacklineSku = mainEntity == null ? void 0 : mainEntity.entity.stacklineSku;
    queryParams.retailerId = mainEntity == null ? void 0 : mainEntity.entity.retailerId;
    queryParams.retailerSku = mainEntity == null ? void 0 : mainEntity.entity.retailerSku;
    queryParams.brandId = mainEntity == null ? void 0 : mainEntity.entity.brandId;
  } else if ((mainEntity == null ? void 0 : mainEntity.type) === "brand") {
    queryParams.brandId = (_a = mainEntity == null ? void 0 : mainEntity.id) == null ? void 0 : _a.toString();
  }
  return queryParams;
};
const trackRetailerProductPageEvent = ({
  trackingEventAction,
  trackingParams,
  analyticsTrack
}) => {
  var _a;
  if (analyticsTrack) {
    (_a = window == null ? void 0 : window.dispatchEvent) == null ? void 0 : _a.call(
      window,
      new CustomEvent("bc-track", {
        bubbles: true,
        detail: {
          eventName: trackingEventAction,
          ...trackingParams
        }
      })
    );
    const eventIndex = ["addToCart", "openRetailerProductPage", "navigateToRetailerProductPage"].indexOf(
      trackingEventAction
    );
    const eventToPublish = [
      AnalyticsTrackingEvent.WEB_APP_ORGANIC_ADD_TO_CART,
      AnalyticsTrackingEvent.WEB_APP_ORGANIC_OPEN_RETAILER_PRODUCT_PAGE,
      AnalyticsTrackingEvent.WEB_APP_ORGANIC_OPEN_RETAILER_PRODUCT_PAGE
      // use same event for navigateToRetailerProductPage
    ][eventIndex];
    if (eventToPublish) {
      analyticsTrack(eventToPublish, {
        ...trackingParams
      });
    } else {
      console.error(`Event not configured for sending to analytics: ${trackingEventAction}`);
    }
  }
};
export {
  buildTrackingParams,
  trackRetailerProductPageEvent
};
//# sourceMappingURL=analytics.js.map
